import React from "react";
import { createRoot } from "react-dom/client";
import "./common/styles/main.scss";
import App from "./app/App";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import moment from "moment";
import "moment/locale/nl";
import { setupTracing } from "./common/utils/tempoTracing";

setupTracing();

moment.locale("nl");

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
    <React.StrictMode>
        <HelmetProvider>
            <Provider store={store}>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<App />} />
                        <Route path="/:slug" element={<App />} />
                    </Routes>
                </BrowserRouter>
            </Provider>
        </HelmetProvider>
    </React.StrictMode>,
);
